import { alias, deserialize, serializable } from 'serializr';

export class TrelloIssueModel {
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable
  public shortUrl: string;
  @serializable
  public idBoard: string;
  @serializable(alias('desc'))
  public description: string;
  @serializable(alias('dateLastActivity'))
  public createdAt: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TrelloIssueModel, input));
  }
}
